import { useMutation } from "react-query";
import clientApi from "./client";
import { forgotPassword, login, register, sendVerification, verifyCode } from "./routes";

// ---------- VERIFY PHONE ACTION -----------

export const verifyPhoneAction = async (body) => {
  return await clientApi.post(verifyCode, body);
};



// ---------- SEND VERIFICATION ACTION -----------

export const sendVerificationAction = async (phone) => {
  return await clientApi.get(sendVerification(phone));
};



// ---------- REGISTER -----------

export const registerAction = async (body) => {
  return await clientApi.post(register, body);
};

export const useRegisterAction = () => {
  return useMutation(registerAction, {
    onSuccess: () => {},
    onError: () => {},
  });
};

// ---------- LOGIN -----------

export const loginAction = async (body) => {
  return await clientApi.post(login, body);
};

// ---------- FORGOT PASSWORD ---------

export const forgotPasswordAction = async(email) => {
  return await clientApi.get(forgotPassword(email))
}
